import React from 'react';
import Table from '../../component/table/table'
import { BASE_END_POINT } from '../../urls'
import axios from 'axios'
import { MDBContainer, MDBRow, MDBCol } from "mdbreact";
import './salesTeam.css'
import { message } from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter, Redirect, NavLink } from 'react-router-dom'
import { ChangeLanguage } from '../../redux/actions/LanguageAction'
import 'moment/locale/ar';
import PaginationButtons from '../../component/pagenation/pagenation';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
class SalesTeam extends React.Component {

  state = {
    salesTeams: [],
    salesTeams2: [],
    loading: true,
    refresh: false,
    page: 1,
    pages: 1,
    count: 0,
  }

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.getSalesTeams(1, false)
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getSalesTeams = (page, refresh) => {
    this.setState({ loading: true })
    let url = `${BASE_END_POINT}salesTeams?page=${page}`
    axios.get(url, {
      headers: {
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log("salesTeams   ", response.data)
        let data = response.data.data.map(item => [
          item.id,
          item.name ? item.name : '',
          item.leader ? item.leader.fullname : '',
          "action"])
        console.log("DATA   ", data)
        this.setState({
          loading: false,
          refresh: false,
          count: response.data.totalCount,
          salesTeams: response.data.data,
          salesTeams2: data,
          page: response.data.page,
          pages: response.data.pageCount,
        })
      })
      .catch(error => {
        console.log("error   ", error.response)
        console.log("error2   ", error)
        this.setState({ loading: false, })
      })
  }
  delete = (id) => {
    console.log("ID   ", id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}salesTeams/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("Row DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.getSalesTeams(this.state.page, true)
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  addNewRecordButton = () => (
    <div style={{ width: '100%' }}>
      <NavLink to="AddSalesTeam">
        <Fab
          style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', float: 'left', margin: '50px 30px', width: '150px', height: '40px', borderRadius: '8px' }}
          letiant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
    </div>
  )

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('SALES-TEAMS')) return <Redirect to='/Home' />

    return (

      <MDBContainer>
        <MDBRow>
          <MDBCol md="12">
            <div className="screenTable">

              <Table
                title={allStrings.salesTeams}
                icon='contact_phone'
                data={this.state.salesTeams}
                data2={this.state.salesTeams2}
                tableColumns={["#", allStrings.name, allStrings.leader, allStrings.action]} loading={this.state.loading}
                deleteItem={(id) => { this.delete(id) }}
                path='/SalesTeamInfo'
                actionIndex={3}
                enableEdit={false}
              />
              <PaginationButtons
                page={this.state.page}
                pages={this.state.pages}
                labels={allStrings}
                onPageChange={(newPage) => {
                  this.getSalesTeams(newPage, true);
                  this.setState({ page: newPage });
                }}
              />
              {this.addNewRecordButton()}

            </div>
          </MDBCol>
        </MDBRow>
      </MDBContainer>

    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDACCEPTEDatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDACCEPTEDatchToProps)(SalesTeam)
);

